import React from 'react';
import { Video, Clock, Sparkles } from 'lucide-react';
import Button from './ui/Button';

/**
 * Banner de upsell na home (apenas exibição + CTA).
 */
const UpsellCard = ({ onCta, alreadyOwned = false }) => {
  return (
    <div className="relative mb-6 overflow-hidden rounded-2xl border border-rose-500/30 bg-zinc-900">
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-rose-600/25 via-transparent to-amber-500/10" />
      <div className="pointer-events-none absolute -right-8 -top-8 h-32 w-32 rounded-full bg-rose-500/20 blur-2xl" />

      <div className="relative p-5">
        <div className="mb-3 flex items-center gap-2">
          <span className="inline-flex items-center gap-1 rounded-full bg-rose-500/20 px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wide text-rose-300 ring-1 ring-rose-400/30">
            <Sparkles className="h-3 w-3" />
            {alreadyOwned ? 'Liberado' : 'Oferta exclusiva'}
          </span>
          <span className="inline-flex items-center gap-1 rounded-full bg-zinc-950/60 px-2.5 py-0.5 text-[11px] font-medium text-zinc-300 ring-1 ring-white/10">
            <Clock className="h-3 w-3" />
            24h
          </span>
        </div>

        <div className="flex gap-4">
          <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-xl bg-rose-500/15 ring-1 ring-rose-400/25">
            <Video className="h-7 w-7 text-rose-400" />
          </div>
          <div className="min-w-0 flex-1">
            <h3 className="text-lg font-semibold leading-tight text-white">
              Show particular
            </h3>
            <p className="mt-1 text-sm leading-snug text-zinc-400">
              {alreadyOwned
                ? 'Seu acesso está ativo. Entre e assista agora.'
                : 'Vídeo exclusivo liberado por 24 horas após a compra. Acesso imediato no seu perfil.'}
            </p>
          </div>
        </div>

        <div className="mt-4 flex items-end justify-between gap-3">
          {alreadyOwned ? (
            <p className="text-sm font-medium text-emerald-400">Acesso ativo</p>
          ) : (
            <div>
              <p className="text-xs text-zinc-500 line-through">R$ 79,90</p>
              <p className="text-2xl font-bold text-white">
                R$ 29,90
                <span className="ml-1.5 text-sm font-normal text-zinc-400">PIX</span>
              </p>
            </div>
          )}
          <Button onClick={onCta} variant="primary" className="shrink-0 !bg-rose-600 hover:!bg-rose-500">
            {alreadyOwned ? 'Assistir agora' : 'Quero agora'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default UpsellCard;
